import camelCase from 'lodash/camelCase';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';

const toCamelCase = (obj) => {
  if (!isObject(obj)) {
    return obj;
  } if (isArray(obj)) {
    return obj.map((vv) => toCamelCase(vv));
  }
  const ret = {};
  Object.entries(obj).forEach(([kk, vv]) => {
    ret[camelCase(kk)] = toCamelCase(vv);
  });
  return ret;
};
export default toCamelCase;
